import {
    UPDATE_SEARCHTDATA_TATTOANCHODUYET,
  } from "./actionTypes";
  

  export const updateDataSearch = (data) => ({
    type: UPDATE_SEARCHTDATA_TATTOANCHODUYET,
    payload: data,
  });
  